import React, { useState, useEffect } from "react";
import { FaBook, FaTimes, FaChevronRight, FaCheck, FaPlus, FaPencilAlt } from "react-icons/fa";
import { BsFillPencilFill } from "react-icons/bs";
import { TbEdit } from "react-icons/tb";
import { FaPencil } from "react-icons/fa6";
import { motion } from "framer-motion";
import ApiService from "../../models/ApiService";

const Lessons = () => {
  const [selectedLesson, setSelectedLesson] = useState(null);
  console.log(selectedLesson);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingSection, setEditingSection] = useState(null);
  const [editingData, setEditingData] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [lessonContent, setLessonContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [error, setError] = useState(null);
  const [id, setId] = useState(null)

  // Fetch lessons on component mount
  useEffect(() => {
    fetchLessons();
  }, []);

  const fetchLessons = async () => {
    setLoading(true);
    try {
      const res = await ApiService.GetAllLesson();
      if (res.data?.success) {
        setLessons(res.data.responseContent || []);
      } else {
        setError("Failed to load lessons");
      }
    } catch (err) {
      console.error("Error fetching lessons:", err);
      setError(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const openLessonModal = async (lesson) => {
    setModalLoading(true);
    setIsModalOpen(true);
    setSelectedLesson(lesson);

    try {
      const res = await ApiService.LessonContent({ lesson_id: lesson.lesson_id });
      console.log(res);

      if (res.data?.success) {
        const content = {
          heading: null,
          Introduction: [],
          Teachings: [],
          Glossary: [],
          match: [],
          MCQs: [],
          Groups: [],
          SoundTable: [],
          Summary: [],
          torf: [],
          VowelSound: [],
          DotTable: [],
          Variants: [],
          Notes: [],
          Compound: [],
          Symbol: [],
          WordTable: [],
        };

        const responseData = Array.isArray(res.data.data) ? res.data.data : [];

        responseData.forEach(item => {
          if (!item?.type || !item?.data) return;
          const itemData = Array.isArray(item.data) ? item.data : [item.data];
          const type = item.type;

          switch (type) {
            case 'heading':
              content.heading = item.data;
              break;
            case 'Introduction':
              content.Introduction.push(...itemData);
              break;
            case 'Teaching':
              content.Teachings.push(...itemData);
              break;
            case 'Glossary':
              content.Glossary.push(...itemData);
              break;
            case 'torf':
            case 't or f':
              content.torf.push(...itemData);
              break;
            case 'match':
              content.match.push(...itemData);
              break;
            case 'mcq':
              content.MCQs.push(...itemData.map(mcq => ({
                ...mcq,
                options: (mcq.option || []).map(opt => ({
                  text: opt,
                  isCorrect: opt === mcq.correct_answer
                }))
              })));
              break;
            case 'Group':
              content.Groups.push(...itemData);
              break;
            case 'SoundTable':
              content.SoundTable.push(...itemData);
              break;
            case 'Summary':
              content.Summary.push(...itemData);
              break;
            case 'Notes':
              content.Notes.push(...itemData);
              break;
            case 'VowelSound':
              content.VowelSound.push(...itemData);
              break;
            case 'DotTable':
              content.DotTable.push(...itemData);
              break;
            case 'Variants':
              content.Variants.push(...itemData);
              break;
            case 'Compound':
              content.Compound.push(...itemData);
              break;
            case 'Symbol':
              content.Symbol.push(...itemData);
              break;
            case 'WordTable':
              content.WordTable.push(...itemData);
              break;
            default:
              console.warn('Unknown content type:', item.type);
          }
        });

        setLessonContent(content);
      } else {
        setError("Failed to load lesson content");
      }
    } catch (err) {
      console.error("Error fetching lesson content:", err);
      setError("Failed to load lesson content. Please try again.");
    } finally {
      setModalLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedLesson(null);
    setLessonContent(null);
  };

  const openEditModal = (sectionType, sectionData) => {
    setEditingSection(sectionType);
    setEditingData(sectionData);
    console.log(sectionData);

    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingSection(null);
    setEditingData(null);
  };

  const handleSaveEdit = async (updatedData) => {
    console.log('Selected Lesson:', selectedLesson);
    console.log('Editing Section:', editingSection);
    console.log('Updated Data:', updatedData);

    try {
      const res = await ApiService.UpdateLesson(
        editingSection,
        updatedData
      );

      if (res.data?.success) {
        await openLessonModal(selectedLesson);
        closeEditModal();
      } else {
        setError("Failed to update content");
      }
    } catch (err) {
      console.error("Error updating content:", err);

      if (err.response?.data?.message?.includes('not found')) {
        setError("This content item doesn't exist. Please refresh the page.");
      } else {
        setError("Failed to update content. Please try again.");
      }
    }
  };



  const handleTogglePublish = async (lessonId, newStatus) => {
    try {
      setLessons(prevLessons =>
        prevLessons.map(lesson =>
          lesson.lesson_id === lessonId
            ? { ...lesson, is_published: newStatus }
            : lesson
        )
      );

      const data = {
        lesson_id: lessonId,
        is_published: newStatus
      };

      const res = await ApiService.PublishStatus(data, lessonId);

      if (!res.data.success) {
        setLessons(prevLessons =>
          prevLessons.map(lesson =>
            lesson.lesson_id === lessonId
              ? { ...lesson, is_published: !newStatus }
              : lesson
          )
        );
        alert('Failed to update publish status');
      }
    } catch (error) {
      console.error('Error updating publish status:', error);
      setLessons(prevLessons =>
        prevLessons.map(lesson =>
          lesson.lesson_id === lessonId
            ? { ...lesson, is_published: !newStatus }
            : lesson
        )
      );
      alert('Error updating publish status');
    }
  };

  const renderLessonContent = () => {
    if (!selectedLesson || !lessonContent) {
      return <div>No content available</div>;
    }

    const hasIntroduction = lessonContent.Introduction?.length > 0;
    const hasTeachings = lessonContent.Teachings?.length > 0;
    const hasMatch = lessonContent.match?.length > 0;
    const hasGlossary = lessonContent.Glossary?.length > 0;
    const hasMCQs = lessonContent.MCQs?.length > 0;
    const hasGroup = lessonContent.Groups && lessonContent.Groups.length > 0;
    const hasSummary = lessonContent.Summary?.length > 0;
    const hasNotes = lessonContent.Notes?.length > 0;
    const hasSoundTable = lessonContent.SoundTable?.length > 0;
    const hasSymbol = lessonContent.Symbol?.length > 0;
    const hasVowelSound = lessonContent.VowelSound?.length > 0;
    const hasDotTable = lessonContent.DotTable?.length > 0;
    const hastorf = lessonContent.torf?.length > 0;
    const hasVariant = lessonContent.Variants?.length > 0;
    const hasCompound = lessonContent.Compound?.length > 0;
    const hasWordTable = lessonContent.WordTable?.length > 0;

    return (
      <div className="space-y-6" id="primary-fonts">
        {/* Introduction Section */}
        {hasIntroduction && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g] relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-[--text-color]">Introduction</h3>
              <button
                onClick={() => openEditModal('Introduction', lessonContent.Introduction)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Introduction"
              >
                <FaPencil className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-4">
              {lessonContent.Introduction.map((intro, idx) => (
                <div key={idx} className="mb-4">
                  {/* Display title if it exists */}
                  {intro.title && (
                    <h4 className="font-bold text-[--text-color-g] mb-2">
                      {intro.title}
                    </h4>
                  )}

                  {/* Display introduction content with line break support */}
                  <div className="text-[--text-color-g] whitespace-pre-line">
                    {intro.introduction}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Teachings Section */}
        {hasTeachings && (
          <div className="bg-white p-6 rounded-lg shadow-sm relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-[--text-color-g]">
                {selectedLesson.category.includes("Alphabet") ? "Letters" : "Teachings"}
              </h3>
              <button
                onClick={() => openEditModal('Teaching', lessonContent.Teachings)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Teachings"
              >
                <FaPencil className="w-5 h-5" />
              </button>
            </div>
            {lessonContent.Teachings?.length > 0 ? (
              <div dir="rtl" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                {lessonContent.Teachings.map((char, idx) => (
                  <div key={idx} className="border border-[--border-color-g] rounded-lg p-4 text-center">
                    {char.letter && <div className="text-2xl font-bold text-[--text-color] mb-2" id="primary-urdu-fonts">{char.letter}</div>}
                    {char.name && <p className="text-[--text-color]">{char.name}</p>}
                    {char.transcription && <p className="text-sm text-[--text-color]">({char.transcription})</p>}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-[--text-color]">No Teachings available</p>
            )}
          </div>
        )}


        {/* Group Model Section */}
        {hasGroup && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g] relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-[--text-color-g]">
                Letter Group
              </h3>
              <button
                onClick={() => openEditModal("Group", lessonContent.Groups)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Groups"
              >
                <FaPencil className="w-5 h-5" />
              </button>
            </div>

            {/* Group items by group_id */}
            {(() => {
              const groupedItems = {};
              lessonContent.Groups.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedItems[groupId]) {
                  groupedItems[groupId] = [];
                }
                groupedItems[groupId].push(item);
              });

              return Object.entries(groupedItems).map(([groupId, groupItems]) => {
                // Collect group-specific notes
                const groupNotes = lessonContent.Notes.filter(
                  (note) =>
                    note.group_id === parseInt(groupId) && note.type === "Group"
                );

                const upperNotes = groupNotes.filter(
                  (note) => note.position === "upper"
                );
                const lowerNotes = groupNotes.filter(
                  (note) => note.position === "lower"
                );

                return (
                  <div key={groupId} className="mb-8 last:mb-0">
                    {/* Group Header */}
                    <h4 className="text-lg font-medium text-[--text-color-g] mb-4 flex items-center">
                      <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                        Group {groupId}
                      </span>
                    </h4>

                    {/* Upper Notes with Edit Button */}
                    {upperNotes.length > 0 && (
                      <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", upperNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Upper Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {upperNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}

                    {/* Group Grid (Cards instead of Table) */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                      {groupItems.map((group, idx) => {
                        const normalizedGroup = {
                          ...group,
                          group: group["group "] || group.group,
                        };
                        return (
                          <div
                            key={idx}
                            className="border border-[--border-color-g] rounded-lg p-4"
                          >
                            <h4 className="font-semibold text-[--text-color] mb-2">
                              {normalizedGroup.group}
                            </h4>
                            <p
                              className="text-2xl font-bold text-[--text-color-g]"
                              dir="rtl"
                              id="primary-urdu-fonts"
                            >
                              {normalizedGroup.letters}
                            </p>
                          </div>
                        );
                      })}
                    </div>

                    {/* Lower Notes with Edit Button */}
                    {lowerNotes.length > 0 && (
                      <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", lowerNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Lower Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {lowerNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0 italic"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              });
            })()}
          </div>
        )}

        {/* sound table */}
        {hasSoundTable && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Sound Table
              </h3>
              {/* <button
                onClick={() => openEditModal("SoundTable", lessonContent.SoundTable)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Sound Table"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group sound tables by group_id */}
            {(() => {
              const groupedSounds = {};
              lessonContent.SoundTable.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedSounds[groupId]) {
                  groupedSounds[groupId] = [];
                }
                groupedSounds[groupId].push(item);
              });

              return Object.entries(groupedSounds).map(([groupId, soundItems]) => {
                const groupNotes = lessonContent.Notes.filter(
                  (note) =>
                    note.group_id === parseInt(groupId) && note.type === "SoundTable"
                );

                const upperNotes = groupNotes.filter(
                  (note) => note.position === "upper"
                );
                const lowerNotes = groupNotes.filter(
                  (note) => note.position === "lower"
                );

                return (
                  <div key={groupId} className="mb-8 last:mb-0">
                    {/* Group Header */}
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="text-lg font-medium text-[--text-color-g] mb-4 flex items-center">
                        <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                          Sound Table {groupId}
                        </span>
                        Sound Model – {soundItems[0]?.name?.split(" ")[0] || "Unknown"} Group
                      </h4>
                      <button
                        onClick={() => openEditModal("SoundTable", soundItems)}
                        className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                        title="Edit This Group"
                      >
                        <FaPencil className="w-4 h-4" />
                      </button>
                    </div>
                    {/* Upper Notes */}
                    {upperNotes.length > 0 && (
                      <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", upperNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Upper Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {upperNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}

                    {/* Sound Table */}
                    <div className="overflow-x-auto mb-4">
                      <table className="min-w-full bg-white border border-[--border-color-g]">
                        <thead>
                          <tr className="bg-[--header-color-g] text-white text-center">
                            <th className="px-4 py-2 border">Sound</th>
                            <th className="px-4 py-2 border">Name</th>
                            <th className="px-4 py-2 border">Letter</th>
                          </tr>
                        </thead>
                        <tbody>
                          {soundItems.map((item) => (
                            <tr
                              key={item.sound_id}
                              className="hover:bg-gray-50 text-[--text-color-g] text-center"
                            >
                              <td className="p-4 border font-medium">{item.sound}</td>
                              <td className="p-4 border text-[--text-color]">
                                {item.name}
                              </td>
                              <td
                                className="p-4 border text-2xl"
                                dir="rtl"
                                id="primary-urdu-fonts"
                              >
                                {item.letter}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Lower Notes */}
                    {lowerNotes.length > 0 && (
                      <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", lowerNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Lower Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {lowerNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0 italic"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              });
            })()}
          </div>
        )}

        {/* Summary Table */}
        {hasSummary && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Summary
              </h3>
              {/* <button
                onClick={() => openEditModal("Summary", lessonContent.Summary)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Summary"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group summary items by group_id */}
            {(() => {
              const groupedSummaries = {};
              lessonContent.Summary.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedSummaries[groupId]) {
                  groupedSummaries[groupId] = [];
                }
                groupedSummaries[groupId].push(item);
              });

              return Object.entries(groupedSummaries).map(([groupId, summaryItems]) => {
                const groupNotes = lessonContent.Notes.filter(
                  (note) =>
                    note.group_id === parseInt(groupId) && note.type === "Summary"
                );

                const upperNotes = groupNotes.filter(
                  (note) => note.position === "upper"
                );
                const lowerNotes = groupNotes.filter(
                  (note) => note.position === "lower"
                );

                return (
                  <div key={groupId} className="mb-8 last:mb-0">
                    {/* Group Header */}
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="text-lg font-medium text-[--text-color-g] mb-4 flex items-center">
                        <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                          Summary {groupId}
                        </span>
                      </h4>

                      <button
                        onClick={() => openEditModal("Summary", summaryItems)}
                        className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                        title="Edit This Group"
                      >
                        <FaPencil className="w-4 h-4" />
                      </button>

                    </div>
                    {/* Upper Notes */}
                    {upperNotes.length > 0 && (
                      <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", upperNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Upper Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {upperNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}

                    {/* Summary Table */}
                    <div className="overflow-x-auto mb-4">
                      <table className="min-w-full bg-white border border-[--border-color-g]">
                        <thead>
                          <tr className="bg-[--header-color-g] text-white text-center">
                            <th className="px-4 py-2 border">Vāo Form</th>
                            <th className="px-4 py-2 border">Sound</th>
                            <th className="px-4 py-2 border">Example</th>
                            <th className="px-4 py-2 border">Transcription</th>
                          </tr>
                        </thead>
                        <tbody>
                          {summaryItems.map((item) => (
                            <tr
                              key={item.Summary_id}
                              className="hover:bg-gray-50 text-[--text-color-g] text-center"
                            >
                              <td className="p-4 border font-medium">
                                {item.vao_form}
                              </td>
                              <td className="p-4 border text-[--text-color]">
                                {item.sound}
                              </td>
                              <td
                                className="p-4 border text-xl"
                                dir="rtl"
                                id="primary-urdu-fonts"
                              >
                                {item.example}
                              </td>
                              <td className="p-4 border text-[--text-color]">
                                {item.transcription}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Lower Notes */}
                    {lowerNotes.length > 0 && (
                      <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", lowerNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Lower Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {lowerNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0 italic"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              });
            })()}
          </div>
        )}

        {/* Symbol Section */}
        {hasSymbol && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Symbols
              </h3>
              {/* <button
                onClick={() => openEditModal("Symbol", lessonContent.Symbol)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Symbols"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group symbol items by group_id */}
            {(() => {
              const groupedSymbols = {};
              lessonContent.Symbol.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedSymbols[groupId]) {
                  groupedSymbols[groupId] = [];
                }
                groupedSymbols[groupId].push(item);
              });

              return Object.entries(groupedSymbols).map(([groupId, symbolItems]) => {
                const groupNotes = lessonContent.Notes.filter(
                  (note) =>
                    note.group_id === parseInt(groupId) && note.type === "Symbol"
                );

                const upperNotes = groupNotes.filter(
                  (note) => note.position === "upper"
                );
                const lowerNotes = groupNotes.filter(
                  (note) => note.position === "lower"
                );

                return (
                  <div key={groupId} className="mb-8 last:mb-0">
                    {/* Group Header */}
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="text-lg font-medium text-[--text-color-g] mb-4 flex items-center">
                        <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                          Symbols {groupId}
                        </span>
                      </h4>
                      <button
                        onClick={() => openEditModal("Symbol", symbolItems)}
                        className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                        title="Edit This Group"
                      >
                        <FaPencil className="w-4 h-4" />
                      </button>
                    </div>

                    {/* Upper Notes */}
                    {upperNotes.length > 0 && (
                      <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", upperNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Upper Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {upperNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}

                    {/* Symbol Table */}
                    <div className="overflow-x-auto mb-4">
                      <table className="min-w-full bg-white border border-[--border-color-g]">
                        <thead>
                          <tr className="bg-[--header-color-g] text-white text-center">
                            <th className="px-4 py-2 border">Symbol</th>
                            <th className="px-4 py-2 border">Name</th>
                            <th className="px-4 py-2 border">Sound</th>
                            <th className="px-4 py-2 border">Example</th>
                            <th className="px-4 py-2 border">Explanation</th>
                          </tr>
                        </thead>
                        <tbody>
                          {symbolItems.map((item) => (
                            <tr
                              key={item.symbol_id}
                              className="hover:bg-gray-50 text-[--text-color] text-center"
                            >
                              <td
                                className="p-4 border text-[--text-color-g] text-3xl"
                                dir="rtl"
                                id="primary-urdu-fonts"
                              >
                                {item.symbol}
                              </td>
                              <td className="px-4 py-2 border font-medium">
                                {item.name}
                              </td>
                              <td className="px-4 py-2 border text-[--text-color-g]">
                                {item.sound}
                              </td>
                              <td
                                className="px-4 py-2 border text-xl"
                                dir="rtl"
                                id="primary-urdu-fonts"
                              >
                                {item.example}
                              </td>
                              <td className="px-4 py-2 border text-[--text-color-g]">
                                {item.explanation}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Lower Notes */}

                    {lowerNotes.length > 0 && (
                      <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", lowerNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Lower Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {lowerNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0 italic"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              });
            })()}
          </div>
        )}

        {/* Dot Table */}
        {hasDotTable && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Dot Table
              </h3>
              {/* <button
                onClick={() => openEditModal("DotTable", lessonContent.DotTable)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Dot Table"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group dot table items by group_id */}
            {(() => {
              const groupedDotTables = {};
              lessonContent.DotTable.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedDotTables[groupId]) {
                  groupedDotTables[groupId] = [];
                }
                groupedDotTables[groupId].push(item);
              });

              return Object.entries(groupedDotTables).map(([groupId, dotTableItems]) => {
                const groupNotes = lessonContent.Notes.filter(
                  (note) =>
                    note.group_id === parseInt(groupId) && note.type === "DotTable"
                );

                const upperNotes = groupNotes.filter(
                  (note) => note.position === "upper"
                );
                const lowerNotes = groupNotes.filter(
                  (note) => note.position === "lower"
                );

                return (
                  <div key={groupId} className="mb-8 last:mb-0">
                    {/* Group Header */}
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="text-lg font-medium text-[--text-color-g] mb-4 flex items-center">
                        <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                          Dot Table {groupId}
                        </span>
                      </h4>
                      <button
                        onClick={() => openEditModal("DotTable", dotTableItems)}
                        className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                        title="Edit This Group"
                      >
                        <FaPencil className="w-4 h-4" />
                      </button>
                    </div>

                    {/* Upper Position Notes */}
                    {upperNotes.length > 0 && (
                      <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", upperNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Upper Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {upperNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}

                    {/* Dot Table */}
                    <div className="overflow-x-auto mb-4">
                      <table className="min-w-full bg-white border border-[--border-color-g]">
                        <thead>
                          <tr className="bg-[--header-color-g] text-white text-center">
                            <th className="px-4 py-2 border">Letter</th>
                            <th className="px-4 py-2 border">Name</th>
                            <th className="px-4 py-2 border">Sound</th>
                            <th className="px-4 py-2 border">Dots</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dotTableItems.map((item) => (
                            <tr
                              key={item.dot_id}
                              className="hover:bg-gray-50 text-[--text-color-g] text-center"
                            >
                              <td
                                className="p-4 border"
                                dir="rtl"
                                id="primary-urdu-fonts"
                              >
                                {item.letter}
                              </td>
                              <td className="p-4 border text-[--text-color]">
                                {item.name}
                              </td>
                              <td className="p-4 border font-medium">
                                {item.sound}
                              </td>
                              <td className="p-4 border text-[--text-color] font-semibold">
                                {item.dots}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Lower Position Notes */}
                    {lowerNotes.length > 0 && (
                      <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", lowerNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Lower Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {lowerNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0 italic"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              });
            })()}
          </div>
        )
        }

        {/* Variant Table */}
        {hasVariant && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Variants
              </h3>
              {/* <button
                onClick={() => openEditModal("Variants", lessonContent.Variants)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Variants"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group variant items by group_id */}
            {(() => {
              const groupedVariants = {};
              lessonContent.Variants.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedVariants[groupId]) {
                  groupedVariants[groupId] = [];
                }
                groupedVariants[groupId].push(item);
              });

              return Object.entries(groupedVariants).map(([groupId, variantItems]) => {
                const groupNotes = lessonContent.Notes.filter(
                  (note) =>
                    note.group_id === parseInt(groupId) && note.type === "Variants"
                );

                const upperNotes = groupNotes.filter(
                  (note) => note.position === "upper"
                );
                const lowerNotes = groupNotes.filter(
                  (note) => note.position === "lower"
                );

                return (
                  <div key={groupId} className="mb-8 last:mb-0">
                    {/* Group Header */}
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="text-lg font-medium text-[--text-color-g] mb-4 flex items-center">
                        <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                          Variants {groupId}
                        </span>
                      </h4>
                      <button
                        onClick={() => openEditModal("Variants", variantItems)}
                        className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                        title="Edit This Group"
                      >
                        <FaPencil className="w-4 h-4" />
                      </button>
                    </div>

                    {/* Upper Position Notes */}
                    {upperNotes.length > 0 && (
                      <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", upperNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Upper Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {upperNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}

                    {/* Variant Table */}
                    <div className="overflow-x-auto mb-4">
                      {variantItems.length > 0 && (
                        <table className="min-w-full bg-white border border-[--border-color-g]">
                          <thead>
                            <tr className="bg-[--header-color-g] text-white text-center">
                              {variantItems.some((i) => i.letter) && (
                                <th className="px-4 py-2 border">Letter</th>
                              )}
                              {variantItems.some((i) => i.sound) && (
                                <th className="px-4 py-2 border">Sound</th>
                              )}
                              {variantItems.some((i) => i.initial) && (
                                <th className="px-4 py-2 border">Initial</th>
                              )}
                              {variantItems.some((i) => i.middle) && (
                                <th className="px-4 py-2 border">Middle</th>
                              )}
                              {variantItems.some((i) => i.final) && (
                                <th className="px-4 py-2 border">Final</th>
                              )}
                              {variantItems.some((i) => i.variants) && (
                                <th className="px-4 py-2 border">Variants</th>
                              )}
                              {variantItems.some((i) => i.name) && (
                                <th className="px-4 py-2 border">Name</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {variantItems.map((item) => (
                              <tr
                                key={item.variant_id}
                                className="hover:bg-gray-50 text-[--text-color-g] text-center"
                              >
                                {variantItems.some((i) => i.letter) && (
                                  <td
                                    className="p-4 border text-xl"
                                    dir="rtl"
                                    id="primary-urdu-fonts"
                                  >
                                    {item.letter}
                                  </td>
                                )}
                                {variantItems.some((i) => i.sound) && (
                                  <td className="px-4 py-2 border text-[--text-color] font-medium">
                                    {item.sound}
                                  </td>
                                )}
                                {variantItems.some((i) => i.initial) && (
                                  <td
                                    className="px-4 py-2 border text-xl"
                                    dir="rtl"
                                    id="primary-urdu-fonts"
                                  >
                                    {item.initial}
                                  </td>
                                )}
                                {variantItems.some((i) => i.middle) && (
                                  <td
                                    className="px-4 py-2 border text-xl"
                                    dir="rtl"
                                    id="primary-urdu-fonts"
                                  >
                                    {item.middle}
                                  </td>
                                )}
                                {variantItems.some((i) => i.final) && (
                                  <td
                                    className="px-4 py-2 border text-xl"
                                    dir="rtl"
                                    id="primary-urdu-fonts"
                                  >
                                    {item.final}
                                  </td>
                                )}
                                {variantItems.some((i) => i.variants) && (
                                  <td className="px-4 py-2 border">
                                    {item.variants}
                                  </td>
                                )}
                                {variantItems.some((i) => i.name) && (
                                  <td className="px-4 py-2 border text-[--text-color]">
                                    {item.name}
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>

                    {/* Lower Position Notes */}
                    {lowerNotes.length > 0 && (
                      <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                        <button
                          onClick={() => openEditModal("Notes", lowerNotes)}
                          className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit Lower Notes"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                        {lowerNotes.map((note) => (
                          <p
                            key={note.note_id}
                            className="text-[--text-color-g] mb-2 last:mb-0 italic"
                          >
                            {note.note}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              });
            })()}
          </div>
        )
        }

        {/* Glossary  */}
        {hasGlossary && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Glossary
              </h3>
              {/* <button
                onClick={() => openEditModal("Glossary", lessonContent.Glossary)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Glossary"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group glossary items by group_id */}
            {(() => {
              const groupedGlossary = {};
              lessonContent.Glossary.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedGlossary[groupId]) {
                  groupedGlossary[groupId] = [];
                }
                groupedGlossary[groupId].push(item);
              });

              return Object.entries(groupedGlossary).map(
                ([groupId, glossaryItems]) => {
                  const groupNotes = lessonContent.Notes.filter(
                    (note) =>
                      note.group_id === parseInt(groupId) &&
                      note.type === "Glossary"
                  );

                  const upperNotes = groupNotes.filter(
                    (note) => note.position === "upper"
                  );
                  const lowerNotes = groupNotes.filter(
                    (note) => note.position === "lower"
                  );

                  const hasExampleData = glossaryItems.some(
                    (item) => item.example && item.example.trim() !== ""
                  );
                  const hasMeaningData = glossaryItems.some(
                    (item) => item.meaning && item.meaning.trim() !== ""
                  );
                  const hasPositionData = glossaryItems.some(
                    (item) => item.position && item.position.trim() !== ""
                  );
                  const hasTranscriptionData = glossaryItems.some(
                    (item) =>
                      item.transcription && item.transcription.trim() !== ""
                  );
                  const hasVowel = glossaryItems.some(
                    (item) =>
                      item.vowel && item.transcription.trim() !== ""
                  );

                  const columnCount = [
                    hasExampleData,
                    hasMeaningData,
                    hasPositionData,
                    hasTranscriptionData,
                    hasVowel,
                  ].filter(Boolean).length;

                  if (columnCount === 0) return null;

                  return (
                    <div key={groupId} className="mb-8 last:mb-0">
                      {/* Group Header */}
                      <div className="flex justify-between items-center  mb-4">
                        <h4 className="text-lg font-medium text-[--text-color-g] mb-4 flex items-center">
                          <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                            Glossary {groupId}
                          </span>

                        </h4>
                        <button
                          onClick={() => openEditModal("Glossary", glossaryItems)}
                          className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit This Group"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                      </div>
                      {/* Upper Position Notes */}
                      {upperNotes.length > 0 && (
                        <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                          <button
                            onClick={() => openEditModal("Notes", upperNotes)}
                            className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                            title="Edit Upper Notes"
                          >
                            <FaPencil className="w-4 h-4" />
                          </button>
                          {upperNotes.map((note) => (
                            <p
                              key={note.note_id}
                              className="text-[--text-color-g] mb-2 last:mb-0"
                            >
                              {note.note}
                            </p>
                          ))}
                        </div>
                      )}

                      {/* Glossary Table */}
                      <div className="overflow-x-auto mb-4">
                        <table className="min-w-full bg-white border border-[--border-color-g]">
                          <thead>
                            <tr className="bg-[--header-color-g] text-white text-center">
                              {hasExampleData && (
                                <th className="p-4 border">Example</th>
                              )}
                              {hasMeaningData && (
                                <th className="p-4 border">Meaning</th>
                              )}
                              {hasPositionData && (
                                <th className="px-4 py-2 border">Position</th>
                              )}
                              {hasTranscriptionData && (
                                <th className="px-4 py-2 border">Transcription</th>
                              )}
                              {hasVowel && (
                                <th className="px-4 py-2 border">Vowel</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {glossaryItems.map((item) => (
                              <tr
                                key={item.Glossary_id}
                                className="hover:bg-gray-50 text-[--text-color-g] text-center"
                              >
                                {hasExampleData && (
                                  <td
                                    className="p-4 border text-xl"
                                    dir="rtl"
                                    id="primary-urdu-fonts"
                                  >
                                    {item.example || "-"}
                                  </td>
                                )}
                                {hasMeaningData && (
                                  <td className="px-4 py-2 border text-[--text-color]">
                                    {item.meaning || "-"}
                                  </td>
                                )}
                                {hasPositionData && (
                                  <td className="px-4 py-2 border">
                                    {item.position || "-"}
                                  </td>
                                )}
                                {hasTranscriptionData && (
                                  <td className="px-4 py-2 border text-[--text-color]">
                                    {item.transcription || "-"}
                                  </td>
                                )}
                                {hasVowel && (
                                  <td className="px-4 py-2 border text-[--text-color]">
                                    {item.vowel || "-"}
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Lower Position Notes */}

                      {lowerNotes.length > 0 && (
                        <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                          <button
                            onClick={() => openEditModal("Notes", lowerNotes)}
                            className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                            title="Edit Lower Notes"
                          >
                            <FaPencil className="w-4 h-4" />
                          </button>
                          {lowerNotes.map((note) => (
                            <p
                              key={note.note_id}
                              className="text-[--text-color-g] mb-2 last:mb-0 italic"
                            >
                              {note.note}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                }
              );
            })()}
          </div>
        )}

        {/* Compound */}
        {hasCompound && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            {/* Section Header */}
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Compound
              </h3>
              {/* <button
                onClick={() => openEditModal("Compound", lessonContent.Compound)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Compound Words"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group compound items by group_id */}
            {(() => {
              const groupedCompounds = {};
              lessonContent.Compound.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedCompounds[groupId]) {
                  groupedCompounds[groupId] = [];
                }
                groupedCompounds[groupId].push(item);
              });

              return Object.entries(groupedCompounds).map(
                ([groupId, compoundItems]) => {
                  const groupNotes = lessonContent.Notes.filter(
                    (note) =>
                      note.group_id === parseInt(groupId) &&
                      note.type === "Compound"
                  );

                  const upperNotes = groupNotes.filter(
                    (note) => note.position === "upper"
                  );
                  const lowerNotes = groupNotes.filter(
                    (note) => note.position === "lower"
                  );

                  return (
                    <div key={groupId} className="mb-8 last:mb-0">
                      {/* Group Header with Edit Button */}
                      <div className="flex justify-between items-center mb-4">
                        <h4 className="text-lg font-medium text-[--text-color-g] flex items-center">
                          <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                            Compound {groupId}
                          </span>
                        </h4>
                        <button
                          onClick={() => openEditModal("Compound", compoundItems)}
                          className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit This Group"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                      </div>

                      {/* Upper Position Notes */}
                      {upperNotes.length > 0 && (
                        <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                          <button
                            onClick={() => openEditModal("Notes", upperNotes)}
                            className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                            title="Edit Upper Notes"
                          >
                            <FaPencil className="w-4 h-4" />
                          </button>
                          {upperNotes.map((note) => (
                            <p
                              key={note.note_id}
                              className="text-[--text-color-g] mb-2 last:mb-0"
                            >
                              {note.note}
                            </p>
                          ))}
                        </div>
                      )}

                      {/* Compound Table */}
                      <div className="overflow-x-auto mb-4">
                        <table className="min-w-full bg-white border border-[--border-color-g]">
                          <thead>
                            <tr className="bg-[--header-color-g] text-white text-center">
                              <th className="px-4 py-2 border">Compound Word</th>
                              <th className="px-4 py-2 border">Components</th>
                              <th className="px-4 py-2 border">Transliteration</th>
                              <th className="px-4 py-2 border">Meaning</th>
                            </tr>
                          </thead>
                          <tbody>
                            {compoundItems.map((item) => (
                              <tr
                                key={item.compound_id}
                                className="hover:bg-gray-50 text-[--text-color-g] text-center"
                              >
                                <td
                                  className="p-4 border text-xl"
                                  dir="rtl"
                                  id="primary-urdu-fonts"
                                >
                                  {item.compound_word}
                                </td>
                                <td
                                  className="px-4 py-2 border text-[--text-color]"
                                  id="primary-urdu-fonts"
                                >
                                  {item.components}
                                </td>
                                <td className="px-4 py-2 border font-medium">
                                  {item.transliteration}
                                </td>
                                <td className="px-4 py-2 border text-[--text-color]">
                                  {item.meaning}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Lower Position Notes */}

                      {lowerNotes.length > 0 && (
                        <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                          <button
                            onClick={() => openEditModal("Notes", lowerNotes)}
                            className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                            title="Edit Lower Notes"
                          >
                            <FaPencil className="w-4 h-4" />
                          </button>
                          {lowerNotes.map((note) => (
                            <p
                              key={note.note_id}
                              className="text-[--text-color-g] mb-2 last:mb-0 italic"
                            >
                              {note.note}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                }
              );
            })()}
          </div>
        )}

        {/* Word table */}
        {hasWordTable && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            {/* Section Header */}
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Word Table
              </h3>
              {/* <button
                onClick={() => openEditModal("WordTable", lessonContent.WordTable)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Word Comparison"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group word table items by group_id */}
            {(() => {
              const groupedWordTables = {};
              lessonContent.WordTable.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedWordTables[groupId]) {
                  groupedWordTables[groupId] = [];
                }
                groupedWordTables[groupId].push(item);
              });

              return Object.entries(groupedWordTables).map(
                ([groupId, wordTableItems]) => {
                  const groupNotes = lessonContent.Notes.filter(
                    (note) =>
                      note.group_id === parseInt(groupId) &&
                      note.type === "WordTable"
                  );

                  const upperNotes = groupNotes.filter(
                    (note) => note.position === "upper"
                  );
                  const lowerNotes = groupNotes.filter(
                    (note) => note.position === "lower"
                  );

                  return (
                    <div key={groupId} className="mb-8 last:mb-0">
                      {/* Group Header with Edit Button */}
                      <div className="flex justify-between items-center mb-4">
                        <h4 className="text-lg font-medium text-[--text-color-g] flex items-center">
                          <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                            Word Table {groupId}
                          </span>
                        </h4>
                        <button
                          onClick={() => openEditModal("WordTable", wordTableItems)}
                          className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit This Group"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                      </div>

                      {/* Upper Position Notes */}
                      {upperNotes.length > 0 && (
                        <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                          <button
                            onClick={() => openEditModal("Notes", upperNotes)}
                            className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                            title="Edit Upper Notes"
                          >
                            <FaPencil className="w-4 h-4" />
                          </button>
                          {upperNotes.map((note) => (
                            <p
                              key={note.note_id}
                              className="text-[--text-color-g] mb-2 last:mb-0"
                            >
                              {note.note}
                            </p>
                          ))}
                        </div>
                      )}


                      {/* Word Table */}
                      <div className="overflow-x-auto mb-4">
                        <table className="min-w-full bg-white border border-[--border-color-g]">
                          <thead>
                            <tr className="bg-[--header-color-g] text-white text-center">
                              <th className="px-4 py-2 border">Word 1</th>
                              <th className="px-4 py-2 border">Meaning 1</th>
                              <th className="px-4 py-2 border">Word 2</th>
                              <th className="px-4 py-2 border">Meaning 2</th>
                            </tr>
                          </thead>
                          <tbody>
                            {wordTableItems.map((item) => (
                              <tr
                                key={item.word_id}
                                className="hover:bg-gray-50 text-[--text-color-g] text-center"
                              >
                                <td
                                  className="p-4 border text-xl"
                                  dir="rtl"
                                  id="primary-urdu-fonts"
                                >
                                  {item.word_1}
                                </td>
                                <td className="px-4 py-2 border text-[--text-color]">
                                  {item.meaning_1}
                                </td>
                                <td
                                  className="px-4 py-2 border text-xl"
                                  dir="rtl"
                                  id="primary-urdu-fonts"
                                >
                                  {item.word_2}
                                </td>
                                <td className="px-4 py-2 border text-[--text-color]">
                                  {item.meaning_2}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Lower Position Notes */}
                      {lowerNotes.length > 0 && (
                        <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                          <button
                            onClick={() => openEditModal("Notes", lowerNotes)}
                            className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                            title="Edit Lower Notes"
                          >
                            <FaPencil className="w-4 h-4" />
                          </button>
                          {lowerNotes.map((note) => (
                            <p
                              key={note.note_id}
                              className="text-[--text-color-g] mb-2 last:mb-0 italic"
                            >
                              {note.note}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                }
              );
            })()}
          </div>
        )}

        {/* Vowel Table */}
        {hasVowelSound && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            {/* Section Header with Edit Button */}
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                Vowel Sounds
              </h3>
              {/* <button
                onClick={() => openEditModal("VowelSound", lessonContent.VowelSound)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Vowel Sounds"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {/* Group vowel sound items by group_id */}
            {(() => {
              const groupedVowelSounds = {};
              lessonContent.VowelSound.forEach((item) => {
                const groupId = item.group_id || "default";
                if (!groupedVowelSounds[groupId]) {
                  groupedVowelSounds[groupId] = [];
                }
                groupedVowelSounds[groupId].push(item);
              });

              return Object.entries(groupedVowelSounds).map(
                ([groupId, vowelSoundItems]) => {
                  const groupNotes = lessonContent.Notes.filter(
                    (note) =>
                      note.group_id === parseInt(groupId) &&
                      note.type === "VowelSound"
                  );

                  const upperNotes = groupNotes.filter(
                    (note) => note.position === "upper"
                  );
                  const lowerNotes = groupNotes.filter(
                    (note) => note.position === "lower"
                  );

                  return (
                    <div key={groupId} className="mb-8 last:mb-0">
                      {/* Group Header with Edit Button */}
                      <div className="flex justify-between items-center mb-4">
                        <h4 className="text-lg font-medium text-[--text-color-g] flex items-center">
                          <span className="bg-[--primary-color] text-white text-xs font-bold px-3 py-1 rounded-full mr-2">
                            Vowel Sounds {groupId}
                          </span>
                        </h4>
                        <button
                          onClick={() => openEditModal("VowelSound", vowelSoundItems)}
                          className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                          title="Edit This Group"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                      </div>

                      {/* Upper Position Notes */}
                      {upperNotes.length > 0 && (
                        <div className="mb-4 bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                          <button
                            onClick={() => openEditModal("Notes", upperNotes)}
                            className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                            title="Edit Upper Notes"
                          >
                            <FaPencil className="w-4 h-4" />
                          </button>
                          {upperNotes.map((note) => (
                            <p
                              key={note.note_id}
                              className="text-[--text-color-g] mb-2 last:mb-0"
                            >
                              {note.note}
                            </p>
                          ))}
                        </div>
                      )}


                      {/* Vowel Sound Table */}
                      <div className="overflow-x-auto mb-4">
                        <table className="min-w-full bg-white border border-[--border-color-g]">
                          <thead>
                            <tr className="bg-[--header-color-g] text-white text-center">
                              <th className="px-4 py-2 border">Vowel Sound</th>
                              <th className="px-4 py-2 border">Written as</th>
                            </tr>
                          </thead>
                          <tbody>
                            {vowelSoundItems.map((item) => (
                              <tr
                                key={item.vowelsound_id}
                                className="hover:bg-gray-50 text-[--text-color-g] text-center"
                              >
                                <td className="p-4 border text-[--text-color] font-medium">
                                  {item.vowel_sound}
                                </td>
                                <td
                                  className="p-4 border text-2xl"
                                  dir="rtl"
                                  id="primary-urdu-fonts"
                                >
                                  {item.written_as}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Lower Position Notes */}
                      {lowerNotes.length > 0 && (
                        <div className="bg-[--bg-color] p-4 rounded-lg border border-[--border-color-o] relative">
                          <button
                            onClick={() => openEditModal("Notes", lowerNotes)}
                            className="absolute top-2 right-2 text-[--primary-color] hover:text-[--secondary-color] p-1"
                            title="Edit Lower Notes"
                          >
                            <FaPencil className="w-4 h-4" />
                          </button>
                          {lowerNotes.map((note) => (
                            <p
                              key={note.note_id}
                              className="text-[--text-color-g] mb-2 last:mb-0 italic"
                            >
                              {note.note}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                }
              );
            })()}
          </div>
        )}

        {/* Matching Exercise */}
        {hasMatch && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            {/* Section Header with Edit Button */}
            <div className="flex justify-between items-center mb-6 pb-2 border-b border-[--border-color-g]">
              <h3 className="text-xl font-semibold text-[--text-color-g] flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-[--primary-color]"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                Match the following
              </h3>
              {/* <button
                onClick={() => openEditModal("Match", lessonContent.match)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit Matching Exercise"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {lessonContent.match.map((item, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: idx * 0.05 }}
                  className="border border-[--border-color-g] rounded-lg p-4 flex justify-between items-center bg-gradient-to-r from-gray-50 to-white hover:from-[--primary-color]/5 hover:to-[--primary-color]/5 transition-all duration-300"
                >
                  <div className="text-[--text-color-g] text-xl font-medium flex items-center">
                    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[--primary-color] text-white text-xs mr-2">
                      {idx + 1}
                    </span>
                    {item.match_left}
                  </div>

                  <div className="flex items-center">
                    <div
                      className="text-xl font-medium text-[--text-color] mx-2"
                      id="primary-urdu-fonts"
                      dir="rtl"
                    >
                      {item.match_right}
                    </div>
                    {/* Inline Edit Button for Each Row */}
                    <button
                      onClick={() => openEditModal("Question", item)}
                      className="text-[--primary-color] hover:text-[--secondary-color] p-1 ml-2"
                      title="Edit This Pair"
                    >
                      <FaPencil className="w-4 h-4" />
                    </button>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        )}

        {/* MCQs */}
        {hasMCQs && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            {/* Header with Main Edit Button */}
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-[--text-color-g]">MCQs</h3>
              {/* <button
                onClick={() => openEditModal("MCQs", lessonContent.MCQs)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit All MCQs"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            {lessonContent.MCQs.map((mcq, index) => (
              <div key={index} className="mb-6 border-b border-gray-200 pb-4">
                {/* Question with Inline Edit Button */}
                <div className="flex justify-between items-center mb-3">
                  <p className="font-medium text-[--text-color-g]">
                    {index + 1}. {mcq.question}
                  </p>
                  <button
                    onClick={() => openEditModal("Question", mcq)}
                    className="text-[--primary-color] hover:text-[--secondary-color] p-1"
                    title="Edit This Question"
                  >
                    <FaPencil className="w-4 h-4" />
                  </button>
                </div>

                {/* Options */}
                <div className="flex flex-wrap gap-4">
                  {mcq.options
                    .filter(
                      (opt) =>
                        opt &&
                        opt.text &&
                        typeof opt.text === "string" &&
                        opt.text.trim() !== ""
                    )
                    .map((opt, idx) => (
                      <div
                        key={idx}
                        className="flex items-center bg-gray-50 px-4 py-2 rounded-lg border border-gray-200"
                      >
                        <label
                          className={
                            opt.isCorrect
                              ? "font-semibold text-[--text-color]"
                              : "text-[--text-color-g]"
                          }
                        >
                          {opt.text}
                        </label>
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* True or false  */}
        {hastorf && (
          <div className="bg-white p-6 rounded-lg shadow-sm border border-[--border-color-g]">
            {/* Header with Edit All Button */}
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-[--text-color-g]">
                True or False
              </h3>
              {/* <button
                onClick={() => openEditModal("TrueFalse", lessonContent.torf)}
                className="text-[--primary-color] hover:text-[--secondary-color] p-2"
                title="Edit All True/False Questions"
              >
                <FaPencil className="w-5 h-5" />
              </button> */}
            </div>

            <div className="space-y-4">
              {lessonContent.torf.map((question, index) => {
                // Normalize correct_answer
                const correctAnswer = question.correct_answer?.trim().toLowerCase();
                const isTrueCorrect = correctAnswer === "true";
                const isFalseCorrect = correctAnswer === "false";

                return (
                  <div
                    key={index}
                    className="border border-gray-200 rounded-lg p-4"
                  >
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                      {/* Question Text with Inline Edit */}
                      <div className="flex-1 flex items-center justify-between">
                        <p className="font-medium text-[--text-color-g]">
                          {index + 1}. {question.question}
                        </p>
                        <button
                          onClick={() => openEditModal("Question", question)}
                          className="text-[--primary-color] hover:text-[--secondary-color] p-1 ml-2"
                          title="Edit This Question"
                        >
                          <FaPencil className="w-4 h-4" />
                        </button>
                      </div>

                      {/* True/False Indicators */}
                      <div className="flex gap-4">
                        <div
                          className={`flex items-center justify-center w-20 h-10 rounded border-2 ${isTrueCorrect
                            ? "bg-green-100 border-green-500 text-green-700 font-semibold"
                            : "border-gray-300 text-gray-500"
                            }`}
                        >
                          True
                        </div>
                        <div
                          className={`flex items-center justify-center w-20 h-10 rounded border-2 ${isFalseCorrect
                            ? "bg-red-100 border-red-500 text-red-700 font-semibold"
                            : "border-gray-300 text-gray-500"
                            }`}
                        >
                          False
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Edit Modal */}
        {isEditModalOpen && editingSection && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-xl shadow-2xl max-w-screen-md w-full max-h-[80vh] overflow-y-auto"
            >
              <div className="bg-[--header-color-g] p-6 text-white relative">
                <div className="flex items-start justify-between">
                  <div>
                    <h2 className="text-xl font-bold">Edit {editingSection}</h2>

                  </div>
                  <button
                    onClick={closeEditModal}
                    className="text-white hover:text-gray-200 p-1"
                  >
                    <FaTimes className="text-xl" />
                  </button>
                </div>
              </div>

              <div className="p-6">
                <EditSectionForm
                  sectionType={editingSection}
                  sectionData={editingData}
                  onSave={handleSaveEdit}
                  onCancel={closeEditModal}
                />
              </div>
            </motion.div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Header */}
      <div className="bg-[--header-color-g] rounded-lg p-4 text-white mb-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold flex items-center gap-3">
              <FaBook className="text-3xl" />
              Urdu Language Lessons
            </h2>
            <p className="opacity-90 mt-1">Step-by-step learning path for Urdu mastery</p>
          </div>
          <div className="bg-white/20 px-4 py-2 rounded-full text-sm">
            {lessons.length} lessons available
          </div>
        </div>
      </div>

      {/* Loading state */}
      {loading && !isModalOpen && (
        <div className="flex justify-center items-center h-40">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[--primary-color]"></div>
        </div>
      )}

      {/* Error state */}
      {error && !loading && (
        <div className="text-center py-8 text-red-500">
          <p>{error}</p>
        </div>
      )}

      {/* Lesson List */}
      {!loading && !error && (
        <div className="grid gap-4">
          {lessons.map((lesson) => (
            <motion.div
              key={lesson.lesson_id}
              whileHover={{ scale: 1.01 }}
              whileTap={{ scale: 0.99 }}
              className="cursor-pointer"
              onClick={() => openLessonModal(lesson)}
            >
              <div className="flex items-center p-4 bg-white hover:bg-gray-50 rounded-lg border border-[--border-color-g] shadow-sm">
                <div className="flex-shrink-0 h-10 w-10 border border-gray-200 rounded-full bg-gray-100 flex items-center justify-center mr-4">
                  <span className="font-medium text-gray-700">{lesson.lesson_id}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-lg font-semibold text-[--text-color-g]">{lesson.lesson_name}</h3>
                      {lesson.category && (
                        <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full mt-1 inline-block">
                          {lesson.category}
                        </span>
                      )}
                    </div>
                    <div className="flex items-center gap-3">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTogglePublish(lesson.lesson_id, !lesson.is_published);
                        }}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${lesson.is_published ? 'bg-green-500' : 'bg-gray-300'
                          }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${lesson.is_published ? 'translate-x-6' : 'translate-x-1'
                            }`}
                        />
                      </button>
                      <span className="text-sm text-gray-600">
                        {lesson.is_published ? 'Published' : 'Unpublished'}
                      </span>
                      <FaChevronRight className="text-gray-500" />
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      )}

      {/* Lesson Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-xl shadow-2xl max-w-screen-lg w-full max-h-[90vh] overflow-y-auto"
          >
            <div className="bg-[--header-color-g] p-6 text-white relative">
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center space-x-3">
                    <span className="text-xl text-white">Lesson</span>
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center shadow-md">
                      <span className="font-semibold text-gray-700">
                        {selectedLesson?.lesson_id}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 mt-1">
                    <p className="opacity-90">{selectedLesson?.lesson_name}</p>
                    {selectedLesson?.category && (
                      <span className="text-xs bg-white/20 px-2 py-1 rounded-full">
                        {selectedLesson.category}
                      </span>
                    )}
                  </div>
                </div>
                <button
                  onClick={closeModal}
                  className="text-white hover:text-gray-200 p-1"
                >
                  <FaTimes className="text-xl" />
                </button>
              </div>
            </div>

            <div className="p-6">
              {modalLoading ? (
                <div className="flex justify-center items-center h-40">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[--primary-color]"></div>
                </div>
              ) : (
                <>
                  {renderLessonContent()}
                  <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4 border-t border-gray-200">
                    <button
                      onClick={closeModal}
                      className="px-4 py-2 bg-[--primary-btn-color] rounded-lg text-white hover:bg-[--secondary-btn-color]"
                    >
                      Close
                    </button>
                  </div>
                </>
              )}
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};

// Edit Section Form Component
const EditSectionForm = ({ sectionType, sectionData, onSave, onCancel }) => {
  const [formData, setFormData] = useState(Array.isArray(sectionData) ? [...sectionData] : [sectionData]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await onSave(formData);

    } finally {
      setIsSubmitting(false);

    }
  };

  const handleInputChange = (index, field, value) => {
    const newData = [...formData];
    newData[index] = { ...newData[index], [field]: value };
    setFormData(newData);
  };



  return (
    <form onSubmit={handleSubmit} className="space-y-4" id="#primary-fonts">
      <h3 className="text-lg font-semibold mb-4">Editing {sectionType}</h3>

      {formData.map((item, index) => (
        <div key={index} className="border border-gray-200 p-4 rounded-lg">
          <div className="flex justify-between items-center mb-3">

          </div>

          {/* Only show content fields, exclude IDs and metadata */}
          {Object.keys(item)
            .filter(field => !['introduction_id', 'sr_no', '_id', 'question_no', 'teaching_id', 'glossary_id', 'group_id', 'type', 'lesson_id', 'id', 'Glossary_id', 'sound_id', 'Summary_id', 'variant_id', 'dot_id', 'compound_id', 'word_id', 'note_id', 'position', 'options', 'symbol_id', 'vowelsound_id'].includes(field))
            .map((field) => (
              <div key={field} className="mb-3">
                <label className="block font-semibold text-[--text-color-g] mb-1 capitalize">
                  {field.replace(/_/g, ' ')}
                </label>

                {Array.isArray(item[field]) ? (
                  item[field].map((opt, optIndex) => (
                    <input
                      key={optIndex}
                      type="text"
                      value={opt ?? ""}
                      onChange={(e) => {
                        const updatedOptions = [...item[field]];
                        updatedOptions[optIndex] = e.target.value;
                        handleInputChange(index, field, updatedOptions);
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md mb-2"
                    />
                  ))
                ) : field === 'introduction' || field === 'note' || field === 'meaning' ||
                  field === 'explanation' || field === 'notes' || field === 'question' ? (
                  <textarea
                    value={item[field] || ''}
                    onChange={(e) => handleInputChange(index, field, e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    rows={4}
                  />
                ) : (
                  <input
                    type="text"
                    value={item[field] || ''}
                    onChange={(e) => handleInputChange(index, field, e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  />
                )}
              </div>
            ))}
        </div>
      ))}



      <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-lg  hover:bg-gray-50 text-sm"
        >
          Cancel
        </button>
        <button
          type="submit"

          className="px-4 py-2 bg-[--primary-btn-color] hover:bg-[--secondary-btn-color] rounded-lg text-white disabled:opacity-50 text-sm"
        >
          {isSubmitting ? 'Saving...' : 'Save Changes'}
        </button>
      </div>
    </form>
  );

};

export default Lessons;